import React, { useEffect, useMemo, useState } from "react"

import EventEmitter from "src/EventEmitter"

import useWebsocket from "hooks/useWebsocket"

import UnreadBadge from "components/Messaging/UnreadBadge"

export type MessageCountDisplayProps = {
  initialCount: number
  viewerId: number
}

const MessageCountDisplay: React.FC<MessageCountDisplayProps> = ({
  initialCount,
  viewerId,
}) => {
  const [count, setCount] = useState<number>(initialCount)
  const channelProps = useMemo(() => {
    return { id: viewerId }
  }, [viewerId])

  useWebsocket({
    channelName: "MessageUserChannel",
    channelProps,
  })

  useEffect(() => {
    const handleEvent = data => {
      setCount(data.count)
    }
    EventEmitter.subscribe("messageReceived", handleEvent)
    EventEmitter.subscribe("messageRead", handleEvent)

    return () => {
      EventEmitter.unsubscribe("messageReceived", handleEvent)
      EventEmitter.unsubscribe("messageRead", handleEvent)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <span className={count > 0 ? "font-bold" : ""}>
      Messages
      <UnreadBadge count={count} blue />
    </span>
  )
}

export default MessageCountDisplay
